import { render } from "./PrinciplesShort.vue?vue&type=template&id=78411520&scoped=true"
import script from "./PrinciplesShort.vue?vue&type=script&lang=js"
export * from "./PrinciplesShort.vue?vue&type=script&lang=js"

import "./PrinciplesShort.vue?vue&type=style&index=0&id=78411520&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78411520"]])

export default __exports__